export const ComplianceAssessmentGuide: React.FC = () => {
  return (
    <div className="guide-page map-3d-sidebar-content">
      <ul>
        <li>
          <span>Step 1 - </span>
          <p>
            Go to <strong>Generate</strong> tab.
          </p>
        </li>
        <li>
          <span>Step 2 - </span>
          <p>
            Select a newer iteration to compare against the active one.
            Comparison is calculated as:{' '}
            <strong>Active – Comparison iteration</strong>.
          </p>
        </li>
        <li>
          <span>Step 3 - </span>
          <p>
            Select polygon layers for <strong>Excavation</strong> and{' '}
            <strong>Dump Zones</strong>, and line layers for{' '}
            <strong>Section Lines</strong> – each must contain at least one
            valid feature.
          </p>
        </li>
        <li>
          <span>Step 4 - </span>
          <p>
            You may optionally enter{' '}
            <strong>Planned Excavation Quantity</strong> and{' '}
            <strong>Planned Dump Quantity</strong> in m³.
          </p>
        </li>
        <li>
          <span>Step 5 - </span>
          <p>
            Click <strong>Generate Request</strong> once all fields are valid.
          </p>
        </li>
        <li>
          <span>Step 6 - </span>
          <p>
            Go to the <strong>History</strong> tab to see past submissions.
          </p>
        </li>
      </ul>
    </div>
  );
};
